import _ from "lodash";
import moment from "moment";
import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { HorizontalAnswerBubblesQuestionSet } from "@/component-library";

import "./CarePlanScreenings.styles.scss";

export function CarePlanScreenings({ gadSummary, phqSummary }) {
  const emptyScreening = (assessmentType) => {
    return (
      <div className="CarePlanScreenings--screening">
        <HorizontalAnswerBubblesQuestionSet
          className={`CarePlanScreenings--${assessmentType} empty`}
          questionSetCategory={assessmentType}
        />

        <div className="CarePlanScreenings--empty-container">
          <div className="CarePlanScreenings--empty">
            <p className="CarePlanScreenings--empty-text">
              {`${assessmentType} hasn’t been completed yet.`}
            </p>
          </div>
        </div>
      </div>
    );
  };

  const renderScreening = (assessmentType, summary) => {
    if (_.isEmpty(summary)) {
      return emptyScreening(assessmentType);
    }

    const scoreText = `Score: ${summary?.score}`;
    const formattedSubmittedDate = moment(summary.submitted_date).local().format("M/D/YYYY");

    return (
      <div className="CarePlanScreenings--screening">
        <HorizontalAnswerBubblesQuestionSet
          answers={{ [scoreText]: [summary.score_index] }}
          className={`CarePlanScreenings--${assessmentType}`}
          optionColStyle={{ marginRight: 6, width: 38 }}
          questionSetCategory={assessmentType}
          questionSetOptions={summary.score_range_labels}
          questionSetOptionsBottomLabels={summary.score_ranges}
        />

        <div className="CarePlanScreenings--screening-subtext">
          <p>Submitted by the {summary.submitted_by}</p>
          <p>{formattedSubmittedDate}</p>
        </div>
      </div>
    );
  };

  return (
    <DashboardCard2 classNameChildren="tw:grid tw:lg:grid-flow-col tw:gap-8" title="Screenings">
      {renderScreening("PHQ-9", phqSummary)}
      {renderScreening("GAD-7", gadSummary)}
    </DashboardCard2>
  );
}
